__webpack_require__.p = "/Mishra-Trading-App/";